var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"us_app"},[_c('Gnb',{attrs:{"isLogin":true}}),_c('section',{staticClass:"user_section"},[_c('UserLnb',{attrs:{"navTitle":_vm.getNavTitle}}),_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }